export default {
  cfg: {
    appId: 'b0c1a43f-02f2-4f02-988b-0044dc53968e',
  },
  definitions: {
    presentation: require('./presentation').default,
    global: { room: { id: '0' } },
  },
  admins: [
    {
      urlKey: 'aK8sWYhD3l',
      token:
        'eseLtxBvO6FMkelgcRhHjnIcyxrHv2WV5HLDphMG83RSnJ6vbxBTDujLuA1519995196081rJXSspHo7QFHnZpe1p4cFOGNx6bA6ZO7NDS5ieE0sjT9q3Et7IxIDzdaL',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/content/devdata/addons/chat/index.js